<i [class]="icon | iconCss"></i>
